import styled from 'styled-components';

export const ReportingRoutingBackground = styled.div`
  margin: 0;
  min-height: 100vh;
  background-image: url('/assets/reporting-hub-login-page.svg');
  background-size: auto 100%;
  background-repeat: no-repeat;
  background-position: right;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};

  overflow: scroll;
`;
